export class Parameters {
  public static API_ROOT_URL = process.env.VUE_APP_ROOT_API_URL;
  public static FIREBASE_CONFIG = {
    apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
    authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  };
}
